<p>all-activity works!</p>
